import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FooterComponent } from './components/layout/footer.component';
import { LayoutComponent } from './components/layout/layout.component';
import { NavComponent } from './components/layout/nav.component';

import { ClipboardModule } from '@angular/cdk/clipboard';
import { LayoutModule } from '@angular/cdk/layout';
import { OverlayModule } from '@angular/cdk/overlay';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { RouterModule } from '@angular/router';
import { AuthModule } from '../auth/auth.module';
import { SharedModule } from '../shared/shared.module';
import { ApplicativeErrorDialogComponent } from './components/applicative-error-dialog/applicative-error-dialog.component';
import { FooterWrapperComponent } from './components/footer-wrapper/footer-wrapper.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { PermissionDeniedDialogComponent } from './components/permission-denied-dialog/permission-denied-dialog.component';
import { RouteAuthorizerDirective } from './directives/route-authorizer.directive';
import { AppendNoAuthChallengeInterceptor } from './interceptors/append-no-auth-challenge.interceptor';
import { GlobalRequestErrorHandlerInterceptor } from './interceptors/global-request-error-handler.interceptor';
import { ServiceTokenRetryInterceptor } from './interceptors/service-token-retry.interceptor';

@NgModule({
  exports: [
    LayoutComponent,
    NavComponent,
    FooterComponent,
    ApplicativeErrorDialogComponent,
    PermissionDeniedDialogComponent,
    PageNotFoundComponent,
    ApplicativeErrorDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    LayoutModule,
    AuthModule,
    ClipboardModule,
    SharedModule,
    OverlayModule,
    LayoutComponent,
    NavComponent,
    FooterComponent,
    RouteAuthorizerDirective,
    ApplicativeErrorDialogComponent,
    PermissionDeniedDialogComponent,
    PageNotFoundComponent,
    FooterWrapperComponent,
  ],
  providers: [
    // ORDERS OF INTERCEPTORS MATTERS
    { provide: HTTP_INTERCEPTORS, useClass: AppendNoAuthChallengeInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: GlobalRequestErrorHandlerInterceptor, multi: true },
    // after the global handler, so it renews a service token before that handler sees the 401
    { provide: HTTP_INTERCEPTORS, useClass: ServiceTokenRetryInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
  ],
})
export class CoreModule {}
